var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "Subheader",
        {
          attrs: {
            title: "Discrete Station Categories",
            search: "Discrete Station Categories",
          },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { dark: "", color: "success" },
              on: {
                click: function ($event) {
                  _vm.showAddType = true
                },
              },
            },
            [
              _c("v-icon", [_vm._v("add")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Button.Add_a_new_Category")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.stationCategories,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "td",
                          [
                            _c("v-icon", [_vm._v(_vm._s(props.item.IconPath))]),
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.Name) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.IconPath))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { depressed: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickEditType(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Button.Manage_Category"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showAddType,
            callback: function ($$v) {
              _vm.showAddType = $$v
            },
            expression: "showAddType",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationStationDiscreteCategory.addTitleMsg"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showAddType = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "addFormRef",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.addForm,
                    callback: function ($$v) {
                      _vm.addForm = $$v
                    },
                    expression: "addForm",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Category Name",
                                  rules: _vm.nameRules,
                                },
                                model: {
                                  value: _vm.newStationCategory.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newStationCategory,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "newStationCategory.name",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Icon Path",
                                  items: _vm.iconList,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-content", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.newStationCategory.iconPath,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newStationCategory,
                                      "iconPath",
                                      $$v
                                    )
                                  },
                                  expression: "newStationCategory.iconPath",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.addNewType()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showUpdateType,
            callback: function ($$v) {
              _vm.showUpdateType = $$v
            },
            expression: "showUpdateType",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationStationDiscreteCategory.editTitleMsg"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showUpdateType = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "editFormRef",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.editForm,
                    callback: function ($$v) {
                      _vm.editForm = $$v
                    },
                    expression: "editForm",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Category Name",
                                  rules: _vm.editNameRules,
                                },
                                model: {
                                  value: _vm.editStationCategory.Name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editStationCategory,
                                      "Name",
                                      $$v
                                    )
                                  },
                                  expression: "editStationCategory.Name",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Icon Path",
                                  items: _vm.iconList,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-content", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.editStationCategory.IconPath,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editStationCategory,
                                      "IconPath",
                                      $$v
                                    )
                                  },
                                  expression: "editStationCategory.IconPath",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.updateStationCategory()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Remove Category"),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AdministrationStationDiscreteCategory.confirmTitleMsg",
                        { msg: _vm.deleteCategory.name }
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AdministrationStationDiscreteCategory.confirmTextMsg"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Remove")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticClass: "snackbarAdjust",
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }